import { useEffect, useState } from "react";
import { Trophy, CalendarDays, Clock, MapPin } from "lucide-react";

const HERO_IMG = "https://images.unsplash.com/photo-1714855175492-72bba7e1af01?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600";
const TARGET = new Date("2026-11-01T06:00:00+05:30").getTime();

const useCountdown = () => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const diff = Math.max(0, TARGET - now);
  return [
    ["दिन", "Days", Math.floor(diff / 864e5)],
    ["घंटे", "Hrs", Math.floor(diff / 36e5) % 24],
    ["मिनट", "Min", Math.floor(diff / 6e4) % 60],
    ["सेकंड", "Sec", Math.floor(diff / 1e3) % 60],
  ];
};

const Pill = ({ icon: Icon, hi, en, testid }) => (
  <div className="hero-pill" data-testid={testid}>
    <Icon size={18} className="text-saffron-light shrink-0" />
    <div>
      <div className="font-hi text-sm font-semibold">{hi}</div>
      <div className="text-[11px] text-white/60">{en}</div>
    </div>
  </div>
);

export const Hero = () => {
  const cd = useCountdown();
  return (
    <section id="top" className="hero" data-testid="hero-section">
      <img src={HERO_IMG} alt="Athletes running on track" className="hero-img" />
      <div className="hero-overlay" />
      <div className="gp-container relative py-10 sm:py-16">
        <div className="fade-up inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-3 py-1 text-xs text-white/90 backdrop-blur">
          <Trophy size={14} className="text-amber-400" /> Haryana Day Sports Meet 2026
        </div>
        <h1 className="fade-up d1 mt-5 font-hi text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-tight">
          ग्राम पाठशाला <span className="text-saffron-light">मानपुर</span>
        </h1>
        <p className="fade-up d2 mt-2 font-hi text-xl sm:text-2xl text-green-300 font-semibold" data-testid="hero-tagline-hi">
          हर गाँव एक लाइब्रेरी
        </p>
        <p className="fade-up d2 text-sm text-white/70" data-testid="hero-tagline-en">Free Library Movement Across India</p>
        <h2 className="fade-up d3 mt-6 font-hi text-base md:text-lg text-white font-semibold">
          हरियाणा दिवस — ग्राम स्तरीय खेल प्रतियोगिता 2026
        </h2>
        <div className="fade-up d3 mt-5 grid grid-cols-1 sm:grid-cols-3 gap-3 max-w-3xl">
          <Pill icon={CalendarDays} hi="दिनांक: 1 नवंबर 2026" en="Date: 1 November 2026" testid="hero-date" />
          <Pill icon={Clock} hi="रिपोर्टिंग: सुबह 6:00 बजे" en="Reporting: 6:00 AM" testid="hero-time" />
          <Pill icon={MapPin} hi="स्थान: मानपुर स्टेडियम" en="Manpur Stadium, Manpur, Haryana" testid="hero-venue" />
        </div>
        <div className="fade-up d4 mt-6 flex gap-2" data-testid="event-countdown-timer">
          {cd.map(([hi, en, v]) => (
            <div key={en} className="cd-box">
              <div className="text-2xl sm:text-3xl font-extrabold text-white tabular-nums">{String(v).padStart(2, "0")}</div>
              <div className="text-[10px] text-white/60 font-hi">{hi} · {en}</div>
            </div>
          ))}
        </div>
        <a href="#register" className="fade-up d4 btn-saffron mt-7 inline-flex" data-testid="hero-register-cta">
          अभी पंजीकरण करें · Register Now
        </a>
      </div>
    </section>
  );
};
